import React from 'react';
import { Text as BaseText, Pressable } from 'react-native';
import styled from 'styled-components/native';

import * as Colors from './colors';
import * as Typography from './typography';
import * as Spacing from './spacing';
import * as Formatting from './formatting';

const colors = Colors;

export const preflightTableStyles = {
  table: {
    marginLeft: 0,
    marginRight: 0,
    width: 'auto',
    minWidth: '98%',
    borderRadius: 10,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: colors.tableBorder,
    borderSpacing: 0,
    borderCollapse: 'separate',
    // overflow: 'hidden',
    marginBottom: 40,
  },
  header: {
    container: {
      backgroundColor: colors.tableHeaderBackground,
      borderColor: colors.tableBorder,
    },
    label: {
      marginLeft: 6,
    },
  },
  functionRow: {
    paddingLeft: 15,
    paddingRight: 9,
  },
  data: {
    cell: {
      backgroundColor: 'white',
      borderLeftStyle: 'none',
      borderRightStyle: 'none',
      borderBottomStyle: 'solid',
      borderWidth: '1px',
      borderColor: colors.tableBorder,
      verticalAlign: 'top',
    },
  },
  pagination: {
    currentNumberButton: {
      backgroundColor: colors.lightBlue,
      color: '#fff',
      padding: '5px',
      borderRadius: '5px',
      borderWidth: '1px',
      borderColor: colors.tableBorder
    },
    button: {
      backgroundColor: '#fff',
      color: colors.darkGrey,
      padding: '5px',
      borderRadius: '5px',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: colors.tableBorder,
      margin: '2.5px',
    },
    label: {
      alignContent: 'center'
    },
    functionRow: {
      justifyContent: 'flex-end'
    }
  }
};

export const PageTitle = ({children}) => {
  return (
    <div style={Typography.pageTitle}>{children}</div>
  )
};

export const Text = styled(BaseText)`
  color: ${colors.primaryText};
`;

export const Hint = styled(BaseText)`
  color: gray;
`;

export const GreenAddNewButton = styled(Pressable)`
  display: flex;
  flexDirection: row;
  gap: 5px;
  border: 1px solid black;
  padding: 10px;
  borderRadius: 5px;
  maxWidth: 250px;
  align: center;
  backgroundColor: ${Colors.green};
`;

export const GreenAddNewButtonText = styled(Text)`
  font-weight: bold;
  color: #fff;
`;

export { Colors, Typography, Spacing, Formatting, colors };
